module.exports = __webpack_public_path__ + "img/wl_prod1_1.1d4be7ff.jpg";